import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import React from "react";
import { useSnackbar } from "notistack";

import PasswordResetToken from "./PasswordResetToken";

const PasswordResetTokenWithSnackbar = (props) => {
  const snackbar = useSnackbar();
  return React.createElement(PasswordResetToken, { ...props, ...snackbar });
};

const mapStateToProps = (_state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(PasswordResetTokenWithSnackbar),
);
